import { defineComponent as _defineComponent } from 'vue'
import useStore from '@/utils/store/common';
import { Moment } from 'moment';
import { computed, ref, watch } from 'vue';
import MapViewerComponent from '@/components/common/MapViewerComponent/MapViewerComponent.vue';

interface IGeometry {
  coordinates: number[][];
  type: string;
}

interface IGPSPosition {
  geometry: IGeometry;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'TrackingRecords',
  props: {
  device: {
    type: Object,
    default: () => ({})
  },
  overlay: {
    type: Boolean
  }
},
  emits: ['close'],
  setup(__props, { emit }) {

const props = __props;





const store = useStore();

const dateRange = ref([] as Moment[]);
const devicePositions = ref([] as number[][]);
const mapState = ref('empty');
const vtrObject = ref({});

const overlay = computed(() => props.overlay);

let dateRangeChanged = false;

const layers: string[] = ['raw'];

function closeOverlay() {
  emit('close', false);
  setTimeout(() => { mapState.value = 'empty'; }, 500);
}

function handleDateRange(newDateRange: Moment[]): void {
  dateRange.value = newDateRange;
  dateRangeChanged = true;
}

function queryDeviceHistory() {
  if (dateRange.value.length && dateRangeChanged) {
    const [
      start,
      end
    ] = dateRange.value.map((date, index): number => {
      const minimumDateScopeInSeconds = 59;

      if ((date.unix() === dateRange.value[0].unix()) && index) {
        return date.unix() + minimumDateScopeInSeconds;
      }
      return date.unix();
    });

    mapState.value = 'loading';
    store.dispatch('devices/queryDevicesLastPositions', {
      deviceId: `${props.device.shortDeviceId}`,
      start,
      end
    }).then((data) => {
      const { features } = data;
      vtrObject.value = data;
      const GPSPositions = features.map((element: IGPSPosition) => element.geometry.coordinates);

      mapState.value = GPSPositions.length > 0 ? 'fetched' : 'noResult';
      devicePositions.value = GPSPositions;
    }).catch(() => {
      mapState.value = 'error';
    });
  }
  dateRangeChanged = false;
}

watch(
  () => overlay,
  () => {
    if (overlay.value && dateRange.value.length) {
      dateRangeChanged = true;
      queryDeviceHistory();
    }
  },
  {
    immediate: true
  }
);

return { __sfc: true,props, emit, store, dateRange, devicePositions, mapState, vtrObject, overlay, dateRangeChanged, layers, closeOverlay, handleDateRange, queryDeviceHistory, MapViewerComponent }
}

})